import { Skeleton, Stack } from '@mui/material';

export const SeverityData = () => {
  return (
    <Stack direction="column" alignItems="stretch" spacing={1} sx={{ py: 1, width: '100%' }}>
      {Array(4)
        .fill('')
        .map((_, idx) => (
          <Stack
            key={idx}
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            sx={{
              px: 1,
              py: 0.625,
              pb: 0.875,
              borderRadius: '4px',
            }}
            spacing={2}
          >
            <Stack direction="column" spacing={0.375}>
              <Skeleton variant="rectangular" width={60} height={16} />
              <Skeleton variant="rectangular" width={40} height={16} />
            </Stack>
            <Skeleton variant="rounded" width={50} height={30} />
          </Stack>
        ))}
    </Stack>
  );
};
